/**
 * Empty caseload fixtures — caseload rows come from Medplum (`useMedplumCaseloadClients`).
 */
export type {
  Client,
  ClientEpisode,
  ClientGroup,
  EpisodeOfCareStatus,
  Provider,
  TransferIntakePreferences,
} from '../types';

import type { Client, ClientGroup, Provider } from '../types';

export const mockClientGroups: ClientGroup[] = [];
export const mockClients: Client[] = [];
export const mockProviders: Provider[] = [];
